(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('countdown-banner-timer')) {
    class CountdownBannerTimer extends HTMLElement {
      connectedCallback() {
        this.endDate = parseInt(this.dataset.end, 10) * 1000;
        this.showDays = this.hasAttribute('data-show-days');
        this.leadingZero = this.hasAttribute('data-leading-zero');
        this.expirationBehavior = this.dataset.expirationBehavior;

        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');

        this.update = this.update.bind(this);
        this.update();
        if (!this.hasEnded) this.interval = setInterval(this.update, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      format(number) {
        return this.leadingZero && number < 10 ? '0' + number : String(number);
      }

      update() {
        const timeLeft = this.endDate ? Math.max(this.endDate - Date.now(), 0) : 0;
        let totalSeconds = Math.floor(timeLeft / 1000);

        // Without days, the hours include the days
        let days = 0;
        if (this.showDays) {
          days = Math.floor(totalSeconds / 86400);
          totalSeconds -= days * 86400;
        }
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (this.days) this.days.textContent = this.format(days);
        this.hours.textContent = this.format(hours);
        this.minutes.textContent = this.format(minutes);
        this.seconds.textContent = this.format(seconds);

        if (timeLeft === 0) this.onComplete();
      }

      onComplete() {
        this.hasEnded = true;
        clearInterval(this.interval);

        if (this.expirationBehavior === 'message' && this.querySelector('.countdown-banner__message')) {
          this.setAttribute('data-expired', '');
        }

        // Keep the section visible in the theme editor so it can still be edited
        if (this.expirationBehavior === 'hide' && !(window.Shopify && window.Shopify.designMode)) {
          const shopifySection = this.closest('.shopify-section');
          if (shopifySection) shopifySection.hidden = true;
        }
      }
    }

    customElements.define('countdown-banner-timer', CountdownBannerTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
